import ContactSupportOutlined from '@mui/icons-material/ContactSupportOutlined';
import ContentPaste from '@mui/icons-material/ContentPaste';
import Home from '@mui/icons-material/Home';
import Person from '@mui/icons-material/Person';
import Receipt from '@mui/icons-material/Receipt';
import type { SvgIconProps } from '@mui/material/SvgIcon';

import { FF_ENABLE_ESCRIPT_ORDERS, FF_ESCRIPT_ENABLE_PRESCRIPTIONS_PAGES } from '@/constants/featureFlags';
import type { Customer } from '@/hooks/user/useCustomer';
import {
  ESCRIPT_ORDERS_ROUTE,
  ESCRIPT_REFILL_ROUTE,
  FAQ_ROUTE,
  PATIENT_ORDERS_ROUTE,
  PATIENT_REFILL_ROUTE,
  PRESCRIPTIONS_ROUTE,
  PROFILE_DETAILS_ROUTE,
} from '@/routes/route-paths';

export const APP_BAR_HEIGHT = '77px';
export interface INavMenu {
  id: number;
  name: string;
  link: string;
  icon: React.ComponentType<SvgIconProps>;
}

interface NavConfigParams {
  flags: Record<string, boolean>;
  customer?: Customer | null;
}

export const getAppBarConfig = ({ flags, customer }: NavConfigParams): INavMenu[] => {
  const isEscriptCustomer = customer?.isExternal && flags[FF_ENABLE_ESCRIPT_ORDERS];
  const enableEscriptPrescriptionPages = flags[FF_ESCRIPT_ENABLE_PRESCRIPTIONS_PAGES];

  return [
    {
      id: 1,
      name: 'Order Medication',
      link: isEscriptCustomer ? ESCRIPT_REFILL_ROUTE : PATIENT_REFILL_ROUTE,
      icon: Home,
    },
    {
      id: 2,
      name: 'Order History',
      link: isEscriptCustomer ? ESCRIPT_ORDERS_ROUTE : PATIENT_ORDERS_ROUTE,
      icon: Receipt,
    },
    ...(enableEscriptPrescriptionPages
      ? [
          {
            id: 3,
            name: 'Prescriptions',
            link: PRESCRIPTIONS_ROUTE,
            icon: ContentPaste,
          },
        ]
      : []),
    {
      id: 4,
      name: 'Profile',
      link: PROFILE_DETAILS_ROUTE,
      icon: Person,
    },
    {
      id: 5,
      name: 'Help',
      link: FAQ_ROUTE,
      icon: ContactSupportOutlined,
    },
  ];
};
